import { createTheme } from "@mui/material/styles"

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    //   background: {
    //     default: "#f7f7f7",
    //   },
    primary: {
      main: "#234285",
    },
    secondary: {
      main: "#94D2C2",
    },
    //   text: {
    //     primary: "#6262A7",
    //     secondary: "#C5C5FC",
    //   },
  },
  typography: {
    fontFamily: 'Roboto, "Helvetica", "Arial", sans-serif',
  },
})
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    // background: {
    //   default: "#000000",
    // },
    // primary: {
    //   main: "#F9F9F9",
    // },
    // text: {
    //   primary: "#ffffff",
    //   secondary: "#fafafa",
    // },
  },
  // typography: {
  //   fontFamily: 'Raleway, "Arial", sans-serif',
  //   allVariants: {
  //     letterSpacing: 1.5,
  //   },
  //   h1: {
  //     fontSize: "1.8rem",
  //   },
  //   h2: {
  //     fontSize: "1.6rem",
  //   },
  // },
})
